<k-area-blocker class="kBulkUploadMenu" [message]="_blockerMessage">
  <div class="kBulkUploadMenuHeader">
    <h1>{{ 'applications.content.bulkUpload.menu.header' | translate }}</h1>
  </div>
  <div class="kBulkUploadMenuBody">
    <p class="kBulkUploadMenuTypesTitle">{{ 'applications.content.bulkUpload.menu.selectType' | translate }}</p>
    <div class="kBulkUploadMenuTypes">
      <button
        pButton
        class="kButtonDefault"
        *ngIf="_kmcPermissions.CONTENT_INGEST_BULK_UPLOAD | kNgIfPermitted"
        [label]="'applications.content.bulkUpload.menu.types.entries' | translate"
        (click)="_invokeFileSelection(_bulkUploadTypes.entries)"
      ></button>
      <button
        pButton
        class="kButtonDefault"
        *ngIf="_kmcPermissions.CONTENT_MANAGE_EDIT_CATEGORIES | kNgIfPermitted"
        [label]="'applications.content.bulkUpload.menu.types.categories' | translate"
        (click)="_invokeFileSelection(_bulkUploadTypes.categories)"
      ></button>
      <button
        pButton
        class="kButtonDefault"
        *ngIf="_kmcPermissions.ADMIN_USER_BULK | kNgIfPermitted"
        [label]="'applications.content.bulkUpload.menu.types.endUsers' | translate"
        (click)="_invokeFileSelection(_bulkUploadTypes.endUsers)"
      ></button>
      <button
        pButton
        class="kButtonDefault"
        *ngIf="_kmcPermissions.CONTENT_MANAGE_CATEGORY_USERS | kNgIfPermitted"
        [label]="'applications.content.bulkUpload.menu.types.endUsersEntitlement' | translate"
        (click)="_invokeFileSelection(_bulkUploadTypes.endUsersEntitlement)"
      ></button>
    </div>
  </div>
</k-area-blocker>

<kFileDialog
  #fileDialog
  *ngIf="_showFileDialog"
  [filter]="_allowedExtensions"
  [allowMultiple]="true"
  (onFileSelected)="_selectFiles($event)"
></kFileDialog>

<kPopupWidget
  #uploadSucceed
  data-aid="uploadSucceed"
  [popupWidth]="440"
  [popupHeight]="233"
  [closeBtn]="false"
  [modal]="true"
  [closeOnClickOutside]="false"
>
  <div class="kSuccessBulkUpload">
    <div class="kSuccessBulkUploadMessage kCenterContent">
      <p>
        {{ 'applications.content.bulkUpload.menu.messages.uploadSuccess.body' | translate }}
        <a (click)="_goToBulkUploadLog()">
          {{ 'applications.content.bulkUpload.menu.messages.uploadSuccess.link' | translate }}
        </a>
      </p>
    </div>

    <div class="kSuccessBulkUploadFooter kCenterContent">
      <button
        pButton
        class="kButtonDefault kSuccessBulkUploadButton"
        [label]="'app.common.ok' | translate"
        (click)="uploadSucceed.close(); onClose.emit()"
      ></button>
    </div>
  </div>
</kPopupWidget>
